import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/v1/notifications', () => {
    return HttpResponse.json({});
  }),
];

export default handlers;
